import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import '@/index.css'
import Router from "@/Router.tsx";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {Toaster} from "@/components/ui/sonner.tsx";

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <Router/>
            <Toaster/>
        </QueryClientProvider>
    </StrictMode>
)
